"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameplayComponentPropsFactory = void 0;
class GameplayComponentPropsFactory {
    constructor(card, style, fileUrls) {
        this.card = card;
        this.style = style;
        this.fileUrls = fileUrls;
    }
    /**
     * createQuestionTopProps
     */
    createQuestionTopProps() {
        return undefined;
    }
    /**
     * createQuestionTextProps
     */
    createQuestionTextProps() {
        return undefined;
    }
    /**
     * createQuestionBottomProps
     */
    createQuestionBottomProps() {
        return undefined;
    }
    /**
     * createQuestionChoiceProps
     */
    createQuestionChoiceProps() {
        return undefined;
    }
    /**
     * createBackgroundProps
     */
    createBackgroundProps() {
        return undefined;
    }
    /**
     * createCorrectAnswerProps
     */
    createCorrectAnswerProps() {
        return undefined;
    }
    /**
     * createIncorrectAnswerProps
     */
    createIncorrectAnswerProps() {
        return undefined;
    }
}
exports.GameplayComponentPropsFactory = GameplayComponentPropsFactory;
